<template>
    <div>
        <div class="intro-text">
            <span>{{ $t('child_contract_status.overview_intro') }}</span>
        </div>
        <div class="overview-container">
            <div class="container-relative">
                <div
                    class="status signedUp"
                    :class="{'signedUp-over': ['signedUp','onWaitinglist','inactive'].indexOf(hoveredStatus) !== -1}"
                    @mouseover="hoveredStatus='signedUp'"
                    @mouseleave="hoveredStatus=null"
                >
                    <kgr-child-status-icon status="signed_up" />
                    <div class="label">
                        {{ $t('child_contract_status.overview_application') }}
                    </div>
                </div>
                <div
                    class="signedUp-to-onWaitingList line line-center"
                    :class="{'line-hover': hoveredStatus==='onWaitinglist'}"
                >
                    <div
                        v-show="hoveredStatus==='onWaitinglist'"
                        class="info infoBox"
                    >
                        {{ $t('child_contract_status_transition.create_on_waiting_list') }}
                    </div>
                </div>
                <div
                    class="signedUp-to-inactive line line-right"
                    :class="{'line-hover': hoveredStatus==='inactive'}"
                >
                    <div
                        v-show="hoveredStatus==='inactive'"
                        class="info infoBox"
                    >
                        {{ $t('child_contract_status_transition.abort_from_waiting_list') }}
                    </div>
                </div>
            </div>

            <div class="container-relative">
                <div
                    class="status onWaitinglist"
                    :class="{'onWaitinglist-over': ['onWaitinglist','waitingForSigning','waitingForStart','active','inactive'].indexOf(hoveredStatus) !== -1}"
                    @mouseover="hoveredStatus='onWaitinglist'"
                    @mouseleave="hoveredStatus=null"
                >
                    <kgr-child-status-icon status="on_waiting_list" />
                    <div class="label">
                        {{ $t('child_contract_status.overview_onWaitinglist') }}
                    </div>
                </div>
                <div
                    class="onWaitinglist-to-waitingForStart line line-right"
                    :class="{'line-hover': hoveredStatus==='waitingForStart'}"
                >
                    <div
                        v-show="hoveredStatus==='waitingForStart'"
                        class="info infoBox"
                    >
                        {{ $t('child_contract_status_transition.create_contract') }}
                    </div>
                </div>
                <div
                    class="onWaitinglist-to-active line line-right"
                    :class="{'line-hover': hoveredStatus==='active'}"
                >
                    <div
                        v-show="hoveredStatus==='active'"
                        class="info infoBox"
                    >
                        {{ $t('child_contract_status_transition.join') }}
                    </div>
                </div>
                <div
                    class="onWaitinglist-to-inactive line line-left"
                    :class="{'line-hover': hoveredStatus==='inactive'}"
                >
                    <div
                        v-show="hoveredStatus==='inactive'"
                        class="info infoBox"
                    >
                        {{ $t('child_contract_status_transition.abort_from_waiting_list') }}
                    </div>
                </div>
                <div
                    class="onWaitinglist-to-waitingForSigning line line-center"
                    :class="{'line-hover': hoveredStatus==='waitingForSigning'}"
                >
                    <div
                        v-show="hoveredStatus==='waitingForSigning'"
                        class="info infoBox"
                    >
                        {{ $t('child_contract_status_transition.create_contract') }}
                    </div>
                </div>
            </div>
            <div class="container-relative">
                <div
                    class="status waitingForSigning"
                    :class="{'waitingForSigning-over': ['waitingForSigning','waitingForStart','inactive'].indexOf(hoveredStatus) !== -1}"
                    @mouseover="hoveredStatus='waitingForSigning'"
                    @mouseleave="hoveredStatus=null"
                >
                    <kgr-child-status-icon status="waiting_for_contract_signing" />
                    <div class="label">
                        {{ $t('child_contract_status.overview_waitingForSigning') }}
                    </div>
                </div>
                <div
                    class="waitingForSigning-to-inactive line line-left"
                    :class="{'line-hover': hoveredStatus==='inactive'}"
                >
                    <div
                        v-show="hoveredStatus==='inactive'"
                        class="info infoBox"
                    >
                        {{ $t('child_contract_status_transition.abort_from_open_contract') }}
                    </div>
                </div>
                <div
                    class="waitingForSigning-to-waitingForStart line line-center"
                    :class="{'line-hover': hoveredStatus==='waitingForStart'}"
                >
                    <div
                        v-show="hoveredStatus==='waitingForStart'"
                        class="info infoBox"
                    >
                        {{ $t('child_contract_status_transition.sign_created_contract') }}
                    </div>
                </div>
            </div>
            <div class="container-relative">
                <div
                    class="status waitingForStart"
                    :class="{'waitingForStart-over': ['waitingForStart','active','inactive'].indexOf(hoveredStatus) !== -1}"
                    @mouseover="hoveredStatus='waitingForStart'"
                    @mouseleave="hoveredStatus=null"
                >
                    <kgr-child-status-icon status="waiting_for_contract_start" />
                    <div class="label">
                        {{ $t('child_contract_status.overview_waitingForContactStart') }}
                    </div>
                </div>
                <div
                    class="waitingForStart-to-inactive line line-left"
                    :class="{'line-hover': hoveredStatus==='inactive'}"
                >
                    <div
                        v-show="hoveredStatus==='inactive'"
                        class="info infoBox"
                    >
                        {{ $t('child_contract_status_transition.abort_from_created_contract') }}
                    </div>
                </div>
                <div
                    class="waitingForStart-to-active line line-center"
                    :class="{'line-hover': hoveredStatus==='active'}"
                >
                    <div
                        v-show="hoveredStatus==='active'"
                        class="info infoBox"
                    >
                        {{ $t('child_contract_status_transition.activate') }}
                    </div>
                </div>
            </div>
            <div class="container-relative">
                <div
                    class="status active"
                    :class="{'active-over': ['active','inactive'].indexOf(hoveredStatus) !== -1}"
                    @mouseover="hoveredStatus='active'"
                    @mouseleave="hoveredStatus=null"
                >
                    <kgr-child-status-icon status="active" />
                    <div class="label">
                        {{ $t('child_contract_status.overview_activ') }}
                    </div>
                </div>
                <div
                    class="active-to-inactive line line-center"
                    :class="{'line-hover': hoveredStatus==='inactive'}"
                >
                    <div
                        v-show="hoveredStatus==='inactive'"
                        class="info infoBox"
                    >
                        {{ $t('child_contract_status_transition.end_contract') }}
                    </div>
                </div>
            </div>
            <div class="container-relative">
                <div
                    class="status inactive"
                    :class="{'inactive-over': ['inactive'].indexOf(hoveredStatus) !== -1}"
                    @mouseover="hoveredStatus='inactive'"
                    @mouseleave="hoveredStatus=null"
                >
                    <kgr-child-status-icon status="archived" />
                    <div class="label">
                        {{ $t('child_contract_status.overview_inactiv') }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ChildStatusIcon from './ChildStatusIcon.vue';

export default {
    components: {
        'kgr-child-status-icon': ChildStatusIcon,
    },
    data() {
        return {
            hoveredStatus: null
        }
    },
}
</script>

<style scoped rel="stylesheet/scss" lang="scss">
    .intro-text {
        margin-left: 5px;
        margin-bottom: 30px;
        font-size: calc(0.867 * var(--kgr-font-size-text));
    }

    .overview-container {
        width: 600px;
        font-size: calc(0.867 * var(--kgr-font-size-text));

        .container-relative {
            position: relative;

            .status {
                width: 200px;
                height: 50px;
                padding-left: 8px;
                padding-right: 8px;
                margin: 70px auto;
                border: 1px solid black;
                border-radius: 5px;
                text-align: center;
                position: relative;
                display: flex;
                align-items: center;
                overflow: auto;
                box-shadow: 3px 3px 12px -1px #aaaaaa;
                .label {
                    margin-left: 8px;
                    width: 152px;
                    text-align: left;
                }
            }
            .status:first-child {
                margin-top: 20px;
            }
            .status:last-child {
                margin-bottom: 20px;
            }
            .signedUp {
                border-color: #cbcbcb;
            }
            .signedUp-over {
                background: rgba(203, 203, 203, 0.3);
            }
            .onWaitinglist, .waitingForSigning, .waitingForStart{
                border-color: #ffc108;
            }
            .onWaitinglist-over, .waitingForSigning-over, .waitingForStart-over{
                background: rgba(255,193,5, 0.3);
            }
            .active {
                border-color: #4daf51;
            }
            .active-over {
                background: rgba(77, 175, 81, 0.3);
            }
            .inactive {
                border-color: #f44437;
            }
            .inactive-over {
                background: rgba(244, 68, 55, 0.3);
            }

            .line {

                &:after {
                    content: '';
                    position: absolute;
                    width: 4px;
                    height: 4px;
                    border-left: 1px solid;
                    border-top: 1px solid;
                    border-color: inherit;
                }
                &.line-right {
                    border-top: 1px solid;
                    border-top-right-radius: 5px;
                    border-right: 1px solid;
                    border-bottom-right-radius: 5px;
                    border-bottom: 1px solid;
                    border-color: #ccc;
                    &:after {
                        transform: rotate(-45deg);
                        bottom: -3px;
                        left: -1px;
                    }
                }

                &.line-left {
                    border-top: 1px solid;
                    border-top-left-radius: 5px;
                    border-left: 1px solid;
                    border-bottom-left-radius: 5px;
                    border-bottom: 1px solid;
                    border-color: #ccc;
                    &:after {
                        transform: rotate(135deg);
                        bottom: -3px;
                        right: -1px;
                    }
                }
                &.line-center {
                    border-left: 1px solid;
                    border-color: #ccc;
                    &:after {
                        transform: rotate(-135deg);
                        bottom: 1px;
                        left: -3px;
                    }
                }
                &.line-hover {
                    border-color: black;
                }
            }
            .info {
                width: max-content;
            }
            .infoBox {
                border: 1px solid;
                position: absolute;
                padding: 3px;
                background-color: white;
                z-index: 10;
            }

            .signedUp-to-inactive {
                width: 150px;
                height: 610px;
                position: absolute;
                left: 405px;
                top: 25px;
                .info {
                    top: 8%;
                    right: -24%;
                }
            }
            .onWaitinglist-to-waitingForStart {
                width: 50px;
                height: 239px;
                position: absolute;
                left: 405px;
                top: 30px;
                .info {
                    top: 19%;
                    right: -35px;
                }
            }
            .onWaitinglist-to-active {
                width: 100px;
                height: 376px;
                position: absolute;
                left: 405px;
                top: 15px;
                .info {
                    top: 16%;
                    right: -37px;
                }
            }

            .onWaitinglist-to-inactive {
                width: 150px;
                height: 502px;
                position: absolute;
                left: 42px;
                top: 25px;
                .info{
                    top: 10%;
                    left: -40px;
                }
            }
            .waitingForSigning-to-inactive {
                width: 100px;
                height: 365px;
                position: absolute;
                left: 92px;
                top: 25px;
                .info {
                    top: 14%;
                    left: -40px;
                }
            }
            .waitingForStart-to-inactive {
                width: 50px;
                height: 228px;
                position: absolute;
                left: 142px;
                top: 25px;
                .info {
                    top: 22%;
                    left: -30px;
                }
            }
            .signedUp-to-onWaitingList,
            .onWaitinglist-to-waitingForSigning,
            .waitingForSigning-to-waitingForStart,
            .waitingForStart-to-active,
            .active-to-inactive {
                height: 61px;
                position: absolute;
                left: 294px;
                top: 57px;
                width: 1px;
                .info {
                    left: -40px;
                    top: 17px;
                    width: max-content;
                }
            }
        }
    }
</style>
